import { useQuery } from 'react-query';
import { queryKeys } from '../config/queryKeys';
import {
  getUserTimezoneFromMembersDatabase,
  getBrowserTimezone,
} from '../services/timezoneResolver';

/**
 * Returns the timezone for a given member, cached indefinitely per userId.
 * Falls back to the browser timezone while loading or if not set in the DB.
 */
export function useMemberTimezone(userId) {
  const { data } = useQuery({
    queryKey: queryKeys.memberTimezone.forUser(userId),
    queryFn: () =>
      getUserTimezoneFromMembersDatabase(userId).then((r) => r.timezone),
    enabled: Boolean(userId),
    staleTime: Infinity,
    cacheTime: 60 * 60 * 1000, // 1 hour
  });

  return data || getBrowserTimezone();
}
